import ModulesStateBasic from 'kts-scaffold-framework/modules/ModulesStateBasic';

/** 模块状态 */
export default class ModulesState extends ModulesStateBasic {
    carouselboxContent: any;
    /** app类型 */
    public appCategoryList: {
        categoryId: number;
        categoryName: string;
    }[] = [];
    /** 私有应用 公有 所有 */
    public isOpen: string = 'all';
    public isOpenList: Array<{
        name: string;
        id: string;
    }> = [
            { id: 'all', name: '全部应用' },
            { id: '1', name: '公开应用' },
            { id: '0', name: '私有应用' },
        ];
    /** 模糊搜索 */
    searchInfo: {
        appName?: string;
        appCategoryId?: any;
        appDescription?: string;
        isOpen?: string;
    } = {
            appName: '',
            appCategoryId: '',
            appDescription: '',
            isOpen: 'all'
        };
    /** 选中的app类型 */
    public appCategory: number = 0;

    /** 分页信息 设置 */
    public pageNum: number = 1;
    public pageSize: number = 12;
    public total: number = 0;
    /** app列表 */
    public appList: {
        appDescription: string; // 应用描述
        appIntroduction: string; // y应用简介
        appIcon: string;
        appId: number;
        appIndexUri: string;
        appKey: string;
        appName: string
        categoryName: string;
        isActivated: number;
    }[] = [];

    search: string;
    screenListData: any[];
    type: string;

    appKey: any;
    checkedAppList: Set<number> = new Set();

    /** 激活弹框 */
    public activTipsM: boolean = false;
    public isReadCheckd: boolean = false;
    public appCategories: Array<any> = [];
    public appAgreementContent: string;
    public appAgreementContentDom: any;
    drawerDetailsVisible: boolean = false;
    agreeReactDom: any;
    checkcedAgreeList: Set<any> = new Set(); // 选择协议的set
    isCheckcedAgreeAll: boolean = false;
    //常用是否已经全选
    isCheckedAll: boolean = false;
    itemDetaials: any = {};
}


// WEBPACK FOOTER //
// ./src/display/platform/AppStore/AppManage/AppBatchActivated/Modules.State.ts